import Typography from '@mui/material/Typography'
import { styled } from '@mui/material/styles'

export const EventsFilterTitle = styled(Typography)`
  font-size: 24px;
  line-height: 24px;
`
export const EventsFilterContainer = styled('div')`
  display: flex;
  gap: 8px;
  align-items: center;
  cursor: pointer;
  width: fit-content;
`
